import React from 'react';
import AccordionItem from './AccordionItem';
import { Mode } from '../../enums';
import './Accordion.scss';

interface Props {
  widgetHeight: number;
  mode: Mode;
  setMode: (newMode: Mode) => void;
}

const Accordion: React.FC<Props> = ({ widgetHeight, mode, setMode }) => {
  return (
    <div className="accordion-bars">
      <div className="accordion-bars__wrapper--inner">
        <AccordionItem
          mode={mode}
          setMode={setMode}
          widgetHeight={widgetHeight}
        />
      </div>
    </div>
  );
};

export default Accordion;
